import styled from 'styled-components';

/** Past this many, the list would outgrow the row it explains. */
const MAX_LISTED = 10;

interface VoiceLanguagesTooltipProps {
  /** Language captions, workspace ones first (see `voiceLanguageSummary`). */
  names: string[];
}

// The body of a voice row's language tooltip: a count as the title, then one
// language per line. A comma paragraph wraps mid-name ("Turkish\n(Türkiye)")
// and reads as a blur; stacked names scan in a second.
export default function VoiceLanguagesTooltip({
  names,
}: VoiceLanguagesTooltipProps) {
  const listed = names.slice(0, MAX_LISTED);
  const more = names.length - listed.length;
  return (
    <Body>
      <strong>
        Speaks {names.length} {names.length === 1 ? 'language' : 'languages'}
      </strong>
      <ul>
        {listed.map(name => (
          <li key={name}>{name}</li>
        ))}
      </ul>
      {more > 0 && <span className="more">and {more} more</span>}
    </Body>
  );
}

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  strong {
    font-weight: var(--font-weight-semibold);
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    white-space: nowrap;
  }
  .more {
    color: var(--text-muted);
  }
`;
